import { SidebarMenuItem } from './SidebarMenuItem'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { useAuth } from '../../../../../app/modules/auth'
import { getDashboardPath } from '../../../../../app/utils/helper'

function getIconByTitle(title) {
  const iconMapping = {
    Dashboard: { icon: 'home', fontIcon: 'home' },
    'PayAiro Users': { icon: 'people', fontIcon: 'people' },
    'User Management': { icon: 'user', fontIcon: 'user' },
    'Access Management': { icon: 'user', fontIcon: 'user' },
    'Team Management': { icon: 'focus', fontIcon: 'focus' },
    Transactions: { icon: 'credit-cart', fontIcon: 'credit-cart' },
    'Set Limits': { icon: 'more-2', fontIcon: 'settings-4' },
    'Fee Settings': { icon: 'wallet', fontIcon: 'wallet' },
    Announcements: { icon: 'notification-circle', fontIcon: 'notification-circle' },
    Support: { icon: 'message-notif', fontIcon: 'message-notif' },
    Settings: { icon: 'gear', fontIcon: 'gear' },
    'Module Assets': { icon: 'element-11', fontIcon: 'element-11' },
    'SDUI Layout Editor': { icon: 'element-7', fontIcon: 'element-7' },
    'SDUI Asset Manager': { icon: 'picture', fontIcon: 'picture' },
    'Blog Access': { icon: 'book', fontIcon: 'book' },
    Rewards: { icon: 'gift', fontIcon: 'gift' },
    Admin: { icon: 'shield-search', fontIcon: 'shield-search' },
  }

  return iconMapping[title] || { icon: 'question-circle', fontIcon: 'question-circle' }
}

export function SidebarMenuMain() {
  const { currentUser, auth } = useAuth()
  const role = currentUser?.role || auth?.role || currentUser?.user_type
  const dashboardPath = getDashboardPath(role, currentUser?.user_type)

  return (
    <>
      {/* Dashboard Link */}
      <SidebarMenuItem title='Dashboard' to={dashboardPath} {...getIconByTitle('Dashboard')} />

      {/* User Management Link */}
      <SidebarMenuItemWithSub
        title='User Management'
        to='/user-management'
        {...getIconByTitle('User Management')}
      >
        <SidebarMenuItem title='PayAiro Users' to='/payairo-users' icon='focus' />
      </SidebarMenuItemWithSub>

      {/* Support Performance */}
      {/* <SidebarMenuItem
        title='Support Performance'
        to='/admin/support-performance'
        {...getIconByTitle('User Management')}
      /> */}

      {/* Transactions */}
      <SidebarMenuItem
        title='Transactions'
        to='/transactions/fiat'
        {...getIconByTitle('Transactions')}
      />

      {/* Rewards Link */}
      <SidebarMenuItemWithSub
        title='Rewards'
        to='/rewards'
        {...getIconByTitle('Rewards')}
      >
        <SidebarMenuItem title='Configuration' to='/rewards/configuration' hasBullet={true} />
        <SidebarMenuItem title='Partners' to='/rewards/partners' hasBullet={true} />
      </SidebarMenuItemWithSub>

      {/* Blog Access Link */}
      <SidebarMenuItem
        title='Blog Access'
        to='/blog-access'
        {...getIconByTitle('Blog Access')}
      />

      {/* Announcements Link */}
      <SidebarMenuItem
        title='Announcements'
        to='/announcements'
        {...getIconByTitle('Announcements')}
      />

      {/* Fee Settings */}
      {/* <SidebarMenuItem
        title='Fee Settings'
        to='/fee-settings'
        {...getIconByTitle('Fee Settings')}
      /> */}

      {/* Support Link */}
      <SidebarMenuItem title='Support' to='/support' {...getIconByTitle('Support')} />

      {/* Settings Link (My Profile) */}
      <SidebarMenuItem title='Settings' to='/settings' {...getIconByTitle('Settings')} />

      {/* Admin Management Link */}
      <SidebarMenuItemWithSub
        title='Admin'
        to='/admin-management'
        {...getIconByTitle('Admin')}
      >
        <SidebarMenuItem
          title='Access Management'
          to='/access-management'
          {...getIconByTitle('Access Management')}
        />
        <SidebarMenuItem
          title='Team Management'
          to='/role-management'
          {...getIconByTitle('Team Management')}
        />
      </SidebarMenuItemWithSub>

      {/* SMS Settings Link */}
      <SidebarMenuItem title='SMS Settings' to='/sms-providers' icon='message-notif' />

      {/* Module Assets */}
      {/* <SidebarMenuItem
        title='Module Assets'
        to='/managed-module-assets'
        {...getIconByTitle('Module Assets')}
      /> */}

      {/* SDUI Content Management */}
      <SidebarMenuItem
        title='SDUI Layout Editor'
        to='/sdui-layout-editor'
        {...getIconByTitle('SDUI Layout Editor')}
      />
      <SidebarMenuItem
        title='SDUI Asset Manager'
        to='/sdui-asset-manager'
        {...getIconByTitle('SDUI Asset Manager')}
      />
    </>
  )
}
